export default{
    VoucherType: 'Loại chứng từ',
    FromLabel: 'Từ ngày',
    ToLabel: 'Đến ngày',
    PeriodLabel: 'Thời gian'
}